var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "content-class": "dialogText", "max-width": "600", light: "" },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c(
            "v-card",
            [
              _c(
                "div",
                {
                  staticClass: "absX",
                  on: {
                    "&click": function ($event) {
                      return _vm.closeDialog(true)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myGray", attrs: { "x-large": "" } },
                    [_vm._v("mdi-window-close")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "spacer-25" }),
              _c("v-card-title", {
                staticClass: "headline text-center d-block",
                domProps: { innerHTML: _vm._s(_vm.question) },
              }),
              _vm.text
                ? _c("v-card-text", [
                    _c("div", { domProps: { innerHTML: _vm._s(_vm.text) } }),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "spacer-15" }),
              _c(
                "v-card-actions",
                { staticClass: "text-center justify-center flex-wrap" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "okBtn btn-df text-none mb-4",
                      attrs: { rounded: "" },
                      nativeOn: {
                        "&click": function ($event) {
                          $event.stopPropagation()
                          return _vm.doYes.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.yesLabel) + " ")]
                  ),
                  _vm.noLabel.length > 0
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "text-none mb-4",
                          class: {
                            okBtn: !_vm.biggerYesButton,
                            "btn-df": !_vm.biggerYesButton,
                            "btn-mini": _vm.biggerYesButton,
                          },
                          attrs: { rounded: "" },
                          nativeOn: {
                            "&click": function ($event) {
                              $event.stopPropagation()
                              return _vm.doNo.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.noLabel) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }